import React from 'react'

import AWSIcon from 'assets/logos/aws.svg?component'
import AzureIcon from 'assets/logos/azure.svg?component'
import GCPIcon from 'assets/logos/google.svg?component'
import GremlinStatusCheckIcon from 'assets/status-check-gremlin.svg?component'
import { IntelligentHealthCheckType } from 'queries/intelligent-health-checks/types'

/**
 * Renders the proper cloud vendor icon as defined by its ICH Icon type, or the Gremlin icon by default.
 */
export function IntelligentHealthCheckVendorIcon({
  type,
  width = 24
}: {
  type: IntelligentHealthCheckType
  width?: number
}) {
  const styles = { width, height: 'auto' }

  switch (type) {
    case IntelligentHealthCheckType.AWS:
      return <AWSIcon css={styles} />
    case IntelligentHealthCheckType.AZURE:
      return <AzureIcon css={styles} />
    case IntelligentHealthCheckType.GCP:
      return <GCPIcon css={styles} />
    default:
      return <GremlinStatusCheckIcon css={styles} />
  }
}
